export default function PostTitle({ children }) {
  return (
    <h1 
      className="text-xl sm:text-[30px] xl:text-[40px] font-bold tracking-tight leading-tight md:leading-snug  text-center md:text-center text-[#ff9245]"
      style={{ textShadow: 'rgba(0, 0, 0, 0.2) 2px 2px 4px' }}
    >
      {children}
    </h1>
  );
}
